import React from "react";
import UiSearch from "../ui/UiSearch";
import "./Order.css";
import UiTag, { UI_TAG_TYPE } from "../ui/UiTag";
import { useState, useEffect, useRef } from "react";
import UiIcon from "../ui/UiIcon";
import { ICON } from "../../assets";
import UiAccordion from "../ui/UiAccordion";
import { getFrDate, SHORT_MONTHS, price } from "../../utils";
import UiButton, { UI_BUTTON_TYPE } from "../ui/UiButton";

function UserOrder({ isOrderVisible, data, toggleOrder, onPdfClick }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [selectedButtons, setSelectedButtons] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [selectedFacture, setFacture] = useState(undefined);

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsDropDownOpen(false);
    }
  };

  const filteredData = data
    .map((item) => ({
      ...item,
      commandes: item.commandes.filter(
        (commande) =>
          (commande.NUMCDC || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          (commande.NUMFAC || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
      ),
    }))
    .filter((item) => item.commandes.length > 0);

  useEffect(() => {
    if (searchTerm && filteredData.length > 0) {
      setActiveIndex(0);
    } else {
      setActiveIndex(null);
    }
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [searchTerm, filteredData.length]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropDownOpen]);

  function renderInputSearchContent() {
    const handleSearch = (term) => {
      setSearchTerm(term);
    };
    return (
      <React.Fragment>
        <div className="order-search">
          <UiSearch onSearch={handleSearch} value={searchTerm} />
        </div>
      </React.Fragment>
    );
  }

  function renderAccordion() {
    const renderOrderCards = (item) => {
      const pdfButtons = (commande, cardIndex, NUMCDC) => {
        const handleButtonClick = (
          commandeId,
          combinedIndex,
          btn = undefined,
        ) => {
          setSelectedButtons(() => ({
            [commandeId]: combinedIndex,
          }));
          if (btn) {
            setFacture({ numcdc: NUMCDC, label: btn.label });
            setIsDropDownOpen(false);
          } else {
            setFacture(undefined);
          }
        };
        const pdfButtons = [
          commande.commande_pdf && {
            label: "Accusé de commande",
            url: commande.commande_pdf,
            documentName: "commande_",
          },
          commande.shipping_pdf && {
            label: "Bon d'expédition",
            url: commande.shipping_pdf,
            documentName: "bon_expedition_",
          },
          commande.bill_pdf && Array.isArray(commande.bill_pdf)
            ? commande.bill_pdf.map((billObj) => {
                const numFac = Object.keys(billObj)[0];
                return {
                  label: `Facture n°${numFac}`,
                  url: billObj[numFac],
                  documentName: "facture_",
                };
              })
            : {
                label: "Facture",
                url: commande.bill_pdf,
                documentName: "facture_",
              },
        ].filter(Boolean);

        return pdfButtons.map((btn, btnIndex) => {
          const combinedIndex = `${cardIndex}${btnIndex}`;
          const isSelected = selectedButtons[commande._id_] === combinedIndex;

          if (btn.length) {
            return (
              <React.Fragment key={combinedIndex}>
                <div className="dropdown card-action--dropdown">
                  <div
                    className="card-action--btn"
                    role="combobox"
                    aria-expanded={isDropDownOpen}
                    aria-haspopup="listbox"
                    tabIndex="0"
                    ref={dropdownRef}
                  >
                    <UiButton
                      size="xl"
                      buttonUiType={
                        isSelected
                          ? [UI_BUTTON_TYPE.ACTIVE]
                          : [UI_BUTTON_TYPE.INACTIVE]
                      }
                      content={
                        <React.Fragment>
                          <div className="invoice-container__action">
                            <UiIcon
                              icon={ICON.unionIcon}
                              alt="arrow"
                              size="md"
                            />
                            <span>
                              {selectedFacture?.numcdc === NUMCDC &&
                              selectedFacture?.label
                                ? selectedFacture.label
                                : "Factures"}
                            </span>
                            <span className="dropdown-arrow">
                              <UiIcon
                                size="md"
                                icon={`${selectedFacture?.numcdc === NUMCDC && isDropDownOpen ? ICON.arrowDownIcon : ICON.arrowUpIcon}`}
                                alt="arrow"
                              />
                            </span>
                          </div>
                        </React.Fragment>
                      }
                      onClick={() => {
                        if (
                          selectedFacture?.numcdc !== NUMCDC ||
                          !selectedFacture?.label
                        ) {
                          setFacture({ numcdc: NUMCDC, label: undefined });
                        }
                        setIsDropDownOpen(!isDropDownOpen);
                        screenWidth < 768 && toggleOrder();
                      }}
                    />
                  </div>
                  {selectedFacture?.numcdc === NUMCDC && isDropDownOpen && (
                    <ul className="dropdown-menu dropdown-menu-right show btn-dropdown-options">
                      {btn.map((dropdownBtn, dropIndex) => (
                        <li
                          key={`${combinedIndex}-${dropIndex}`}
                          className="dropdown-item btn-dropdown-option"
                          onClick={() => {
                            onPdfClick({
                              url: dropdownBtn.url,
                              piece: commande.piece,
                              NUMCDC,
                              documentName: dropdownBtn.documentName,
                            });
                            handleButtonClick(
                              commande._id_,
                              combinedIndex,
                              dropdownBtn,
                            );
                          }}
                          role="option"
                          aria-selected={selectedFacture === dropdownBtn.label}
                          tabIndex="0"
                        >
                          {dropdownBtn.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment key={combinedIndex}>
                <div className="card-action--btn">
                  <UiButton
                    size="xl"
                    buttonUiType={
                      isSelected
                        ? [UI_BUTTON_TYPE.ACTIVE]
                        : [UI_BUTTON_TYPE.INACTIVE]
                    }
                    content={
                      <React.Fragment>
                        <div className="invoice-container__action">
                          <UiIcon icon={ICON.unionIcon} alt="arrow" size="md" />
                          <span>{btn.label}</span>
                        </div>
                      </React.Fragment>
                    }
                    onClick={() => {
                      onPdfClick({
                        url: btn.url,
                        piece: commande.piece,
                        NUMCDC,
                        documentName: btn.documentName,
                      });
                      handleButtonClick(commande._id_, combinedIndex);
                      screenWidth < 768 && toggleOrder();
                    }}
                  />
                </div>
              </React.Fragment>
            );
          }
        });
      };
      return item.commandes.map((commande, cardIndex) => {
        const date = new Date(commande.CDC_DATE);
        let status = "";
        let tagType = UI_TAG_TYPE.paleOrange;

        if (
          commande.commande_pdf &&
          !commande.shipping_pdf &&
          !commande.bill_pdf
        ) {
          status = "En attente de préparation";
          tagType = UI_TAG_TYPE.paleOrange;
        } else if (
          commande.commande_pdf &&
          commande.shipping_pdf &&
          !commande.bill_pdf
        ) {
          status = "En livraison";
          tagType = UI_TAG_TYPE.lightBlue;
        } else if (commande.bill_pdf) {
          status = "Livrée";
          tagType = UI_TAG_TYPE.lightGreen;
        }
        return (
          <React.Fragment key={cardIndex}>
            <div className="card-content">
              <div className="card-row" key={commande._id_}>
                <div className="card-text">
                  {commande.NUMCDC && commande.NUMCDC != 0
                    ? `Commande n°${commande.NUMCDC}`
                    : `Facture n° ${commande.NUMFAC}`}
                </div>
                <UiTag
                  className="card-tag"
                  content={status}
                  fontWeight="950"
                  uiTagType={tagType}
                  size="sm"
                />
              </div>
              <div className="card-row">
                <div className="card-text">
                  <span className="card-text--bold">
                    {SHORT_MONTHS[date.getMonth()]}
                  </span>
                  <span>{getFrDate(commande.CDC_DATE)}</span>
                </div>
                <div className="card-text">
                  {price(commande.CDC_MONTANT_HT)} € H.T
                </div>
              </div>
              <div className="card-row__action">
                <div className="card-text">Voir:</div>
                <div className="card-action">
                  {pdfButtons(commande, cardIndex, commande.NUMCDC)}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      });
    };

    if (filteredData.length === 0 && searchTerm) {
      return <span>Aucune commande trouvée pour le numéro {searchTerm}</span>;
    }

    return filteredData.map((item, index) => (
      <React.Fragment key={index}>
        <UiAccordion
          headerLabel={item.year}
          renderAccordionBodyContent={renderOrderCards(item)}
          isActive={searchTerm ? true : activeIndex === index}
          onClick={() => setActiveIndex(activeIndex === index ? null : index)}
        />
      </React.Fragment>
    ));
  }

  return (
    <React.Fragment>
      <div
        className={`order-container ${
          !isOrderVisible ? "element-hidden-display" : ""
        }`}
        ref={buttonRef}
      >
        {renderInputSearchContent()}
        {renderAccordion()}
      </div>
    </React.Fragment>
  );
}

export default UserOrder;
